import { Box, ListItem, ListItemText, useTheme } from "@mui/material";
import * as React from "react";

import { useAuth } from "@/providers";
import { EditFieldButton } from "@/shared/components";
import { ActionRecord, ActionReference } from "@/shared/domain/actions";
import {
  TriggerView,
  UpdateScheduledTriggerRequest,
  UpdateTriggerRequest,
} from "@/shared/domain/actions/TriggerRecord";

import { isActionReference } from "../../model";
import { ActionLink, ActionSelector } from "../action";

interface EditableActionSelectorProps {
  trigger: TriggerView;
  onChange: (
    updates: UpdateTriggerRequest | UpdateScheduledTriggerRequest,
  ) => void;
  setErrorText: (arg: string) => void;
}

export const EditableActionSelector: React.FC<EditableActionSelectorProps> = ({
  trigger,
  onChange,
  setErrorText,
}) => {
  const theme = useTheme();

  const [showEditableIcon, setShowEditableIcon] = React.useState(false);
  const [editable, setEditable] = React.useState(false);
  const [selection, setSelection] = React.useState<
    ActionRecord | ActionReference | null
  >(trigger.action);
  const { currentOrganization } = useAuth();

  const updateRecord = () => {
    setErrorText("");

    onChange({
      action_name: selection?.name,
      action_owner_id: isActionReference(selection)
        ? selection.owner
        : selection?.org_id,
      // Wipe parameter values if the action on a trigger gets changed
      parameter_values: {},
    });
  };

  let content: JSX.Element | string = "None";
  if (editable) {
    content = (
      <Box sx={{ mt: theme.spacing(1) }}>
        <ActionSelector
          action={selection}
          setAction={setSelection}
          currentOrg={currentOrganization}
        />
      </Box>
    );
  } else if (selection) {
    content = <ActionLink action={trigger.action} />;
  }

  const onClick = () => {
    if (editable) {
      updateRecord();
    }
    setEditable(!editable);
  };

  return (
    <ListItem
      onMouseOver={() => {
        setShowEditableIcon(true);
      }}
      onMouseLeave={() => {
        setShowEditableIcon(false);
      }}
    >
      <ListItemText
        primaryTypographyProps={{
          component: "span",
        }}
        sx={{
          mt: theme.spacing(0.5),
        }}
        primary={
          <>
            <span>Action</span>
            <EditFieldButton
              editable={editable}
              showEditableIcon={showEditableIcon}
              onClick={() => {
                void onClick();
              }}
            />
          </>
        }
        secondaryTypographyProps={{
          component: "span",
        }}
        secondary={content}
      />
    </ListItem>
  );
};
